import { useFavorisStore } from '../../favoris/favorisStore'
import { useRechercheVirementStore } from './useRechercheVirementStore'
import { useVirementRoutingService } from '../../detail/virement/useVirementRoutingService'

export function useRechercheVirementActions() {
  const storeDemande = useRechercheVirementStore()
  const routingService = useVirementRoutingService()
  const { addFavori } = useFavorisStore()

  function displayVirement(code: string) {
    routingService.navigateToWithKey(code)
  }

  async function addFavoris() {
    addFavori('virement', storeDemande.pageRequest!)
  }
  return { addFavoris, displayVirement }
}
